import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const LocationLocation = lazy(() => import('./location/Location'));
const LocationsLocations = lazy(() => import('./locations/Locations'));

const LocationsAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/settings/locations/:locationUid',
			element: <LocationLocation />
		},
		{
			path: '/apps/settings/locations',
			element: <LocationsLocations />
		}
	]
};

export default LocationsAppConfig;
